export default "__VITE_ASSET__CdpwUR0k__"